'use client';

import { useMemo } from 'react';

import { StepBullet } from './components';

type StepperProps = {
  steps: number[];
  currentStep: number;
};

export const Stepper = ({ steps, currentStep }: StepperProps) => {
  const lastStep = useMemo(() => steps[steps.length - 1], [steps]);

  return (
    <div className="flex items-center justify-center w-screen h-14 border-b border-b-foreground/10 bg-background/10">
      {steps.map((step) => {
        const isLastStep = step === lastStep;

        return (
          <div key={step} className="flex items-center">
            <StepBullet step={step} currentStep={currentStep} isLastStep={isLastStep} />
            {!isLastStep && (
              <div className="flex-1 min-w-16 sm:min-w-16 md:min-w-36 lg:min-w-48 h-0.5 bg-foreground/10" />
            )}
          </div>
        );
      })}
    </div>
  );
};
